import type {
  GetProductReviewsParams,
  GetProductReviewsResponse,
  ProductReview,
} from "@/types/productReviews";

const MOCK_REVIEWS_TEMPLATE: Omit<ProductReview, "id" | "source_review_id">[] =
  [
    {
      source: "shopify",
      score: 5,
      votes_up: 24,
      votes_down: 1,
      content:
        "Exceeded expectations — comfortable right out of the box and true to size. The material feels premium and stitching has held up after several washes. I ordered two colors and both matched the site photos. Delivery was quick and packaging was minimal but protective. Would recommend sizing up if you are between sizes; I went with my usual and it fits snugly but comfortably. Overall one of the better purchases I have made this season and I have already suggested it to friends who asked where I got it.",
      title: "Perfect for daily wear",
      comment: null,
      recog_id: null,
      created_at: "2026-04-10T14:32:00",
      verified_buyer: true,
      published: true,
      custom_fields: { locale: "en-US" },
      images_data: [
        { url: "https://picsum.photos/id/1011/400/400" },
        { url: "https://picsum.photos/id/1012/400/400" },
        { original_url: "https://picsum.photos/id/1013/400/400" },
      ],
      tags: ["Top Review", "comfort"],
      variant_info: { size: "M", color: "Black" },
      user: { display_name: "Jordan K.", initials: "JK" },
    },
    {
      source: "shopify",
      score: 4,
      votes_up: 8,
      votes_down: 0,
      content: "Great quality; shipping was a day later than estimated.",
      title: "Almost perfect",
      comment: null,
      recog_id: null,
      created_at: "2026-04-08T09:15:00",
      verified_buyer: true,
      published: true,
      custom_fields: {},
      images_data: [{ url: "https://picsum.photos/id/1025/400/400" }],
      tags: ["Quality"],
      variant_info: {},
      user: { display_name: "Sam T." },
    },
    {
      source: "yotpo",
      score: 5,
      votes_up: 41,
      votes_down: 2,
      content: null,
      title: "Love it",
      comment: "Would buy again in another color.",
      recog_id: null,
      created_at: "2026-04-01T11:00:00",
      verified_buyer: false,
      published: true,
      custom_fields: {},
      images_data: [],
      tags: [],
      variant_info: { sku: "SKU-DEMO-01" },
      user: {},
    },
  ];

function buildReviewsForProduct(
  productId: string,
  maxCount: number,
): ProductReview[] {
  const count = Math.min(Math.max(maxCount, 1), MOCK_REVIEWS_TEMPLATE.length);
  return MOCK_REVIEWS_TEMPLATE.slice(0, count).map((row, index) => ({
    ...row,
    id: `${productId}-review-${index + 1}`,
    source_review_id: `${productId}-src-${index + 1}`,
  }));
}

/**
 * Sample product reviews for tests, local dev when {@link USE_MOCKS} is enabled,
 * and MSW handlers. Aligns with GET /{site_id}/products/reviews/.
 */
export function resolveMockProductReviews(
  _siteId: string,
  params: GetProductReviewsParams,
): GetProductReviewsResponse {
  const cap = Math.min(Math.max(params.limit, 1), 100);
  return {
    reviews: Object.fromEntries(
      params.ids.map((productId) => [
        productId,
        buildReviewsForProduct(productId, cap),
      ]),
    ),
  };
}
